import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTypographyMultiple24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconTypographyMultiple24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 5.012h12.504v2.282a.75.75 0 0 1-1.5 0v-.782H9V17.5h1.25a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1 0-1.5H7.5V6.512h-4v.782a.75.75 0 0 1-1.5 0zM16.5 11h-4V9.5H22V11h-4v8h-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTypographyMultiple24);
